import { ScheduleCallRoute } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { Text, TextLink, Truncated } from '@frontend/design-system';
import { usePhoneSettingsShallowStore } from '../store/settings';

export const CallRoutesLink = ({ scheduleCallRoutes }: { scheduleCallRoutes: ScheduleCallRoute[] }) => {
  const { t } = useTranslation('phone');
  const { navigate } = useSettingsNavigate();
  const { settingsTenantLocation } = usePhoneSettingsShallowStore('settingsTenantLocation');
  const hasPhoneFullAccess = hasSchemaACL(settingsTenantLocation?.id ?? '', Permission.PHONE_FULL_ACCESS);

  return (
    <>
      {scheduleCallRoutes.length === 1 &&
        (hasPhoneFullAccess ? (
          <Truncated
            as={TextLink}
            textAlign='left'
            css={{ maxWidth: theme.spacing(54) }}
            onClick={() =>
              navigate({
                to: '/phone/call-routes/:id',
                params: { id: scheduleCallRoutes[0].id ?? '' },
              })
            }
          >
            {scheduleCallRoutes[0].name}
          </Truncated>
        ) : (
          <Truncated as={Text} size='large' color='default'>
            {scheduleCallRoutes[0].name}
          </Truncated>
        ))}

      {scheduleCallRoutes.length > 1 && (
        <TextLink
          onClick={() => {
            // TODO: Open up the call route side panel
            console.log('Open call route side panel', scheduleCallRoutes);
          }}
        >
          {t('{{count}} Call Routes', { count: scheduleCallRoutes.length })}
        </TextLink>
      )}
    </>
  );
};
